import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Armazem } from '../interface/armazem';

@Injectable({
  providedIn: 'root'
})
export class ArmazemLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrarmazem`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<Armazem> {
    return this.httpClient.get<Armazem>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CNNRCODIGO', optional: true, gridColumns: 6, label: 'Codigo'},
      {property: 'CNNRDESCRI', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CNNRCODIGO', label: 'Codigo'},
      {property: 'CNNRDESCRI', label: 'Descrição'},
    ];
  }

  getFieldFormater(value: Armazem): string {
    return `${value.CNNRCODIGO} - ${value.CNNRDESCRI}`;
  }
}
